<div class="ui-g">
  <div class="ui-sm-12 ui-md-12 ui-lg-12 ui-xl-12">
      <p-panel header="{{ 'add_photo' | translate }}" [toggleable]="false" [collapsed]="false" [style]="{'margin-bottom':'10px'}">
          <app-image-cropper (croppedImage)="onCroppedImage($event)"></app-image-cropper>

          <div class="ui-g">
            <div class="ui-sm-12 ui-md-6 ui-lg-4 ui-xl-3" style="margin: auto;">
              <button pButton type="button" label="{{ 'save' | translate }}" (click)="saveImage()" [disabled]="croppedImage == null" class="ui-button-info" style="width:100%"></button>
            </div>
          </div>
      </p-panel>
  </div>
</div>
